<div class="search">
    <input
        type="search"
        [placeholder]="placeholder"
        [value]="value"
        (input)="updateValue($event.target.value)" />
</div>
